import { SxProps } from '@mui/system';
import React, { useState } from 'react';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import { Box } from '@mui/material';

export interface SlShowMoreProps {
  /**
   * Full list of items to render
   */
  items: unknown[];
  /**
   * Number of initial items and number of additional items to show when the "Show more" button is clicked
   */
  itemsPerChunk?: number;
  /**
   * Renders all the visible items.
   */
  renderItems: (items: unknown[]) => React.ReactNode;

  sx?: SxProps;
}

/**
 * Component commonly used in filter modals where we display a list of options
 * and allow the user to continuously show more options.
 *
 * For example, if showing a list of checkboxes for categories, the user can view
 * the first few categories and then click "Show more" to view more categories.
 */
export function SlShowMore({ items, itemsPerChunk = 6, renderItems, sx }: SlShowMoreProps) {
  const [visibleItems, setVisibleItems] = useState(itemsPerChunk);

  return (
    <Box sx={sx}>
      {renderItems(items.slice(0, visibleItems))}
      {visibleItems < items.length && (
        <Text
          variant="subtitle2"
          underlined
          sx={{
            marginTop: '32px',
            cursor: 'pointer'
          }}
          onClick={() => setVisibleItems((prev) => Math.min(items.length, prev + itemsPerChunk))}
        >
          Show more
        </Text>
      )}
    </Box>
  );
}
